import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';
import { BaseDataService, NotificationService, QueryParameter } from 'yt-ng-framework';

@Component({
  selector: 'app-postavi-odgovorno-lice',
  templateUrl: './postavi-odgovorno-lice.component.html'
})
export class PostaviOdgovornoLiceComponent implements OnInit {

  constructor(        
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService) 
    { }

  rbItems=[];
  radioValue: any;
  odgovornoLiceID: string | number;
  companyID: string | number;
  izmeni_sve: boolean;
  @Input() Parameters: QueryParameter[];

  ngOnInit() {

        this.rbItems=[
            {
                Name : 'SVI',
                Value : 'FIRMA.ODGLICE.CHANGE.OPCIJA1.SINGULAR'//Na sve "vrste dokumenata".
            },
            {
                Name : 'NULL',
                Value : 'FIRMA.ODGLICE.CHANGE.OPCIJA2.SINGULAR'
            },
            {
              Name : 'EXIST',
              Value : 'FIRMA.ODGLICE.CHANGE.OPCIJA3.SINGULAR'
            },
            {
              Name : 'NONE',
              Value : 'FIRMA.ODGLICE.CHANGE.OPCIJA4.SINGULAR'
            },

        ];

        this.odgovornoLiceID = this.Parameters[0].Value;
        this.companyID = this.Parameters[1].Value;
                            
    };

    onRadioItemsChange(event: any){
      this.radioValue = event.target.value;
    }

Save(){
  if(typeof(this.radioValue) === 'undefined')
    alert('Morate odabrati nešto od ponudjenih opcija!')
  else{
    switch(this.radioValue){
      case 'NONE':{
        this.activeModal.close();
        return;
      }
    }

  
    let parameters = { odgovornoLiceID: this.odgovornoLiceID, izmeniSve: this.radioValue, CompanyId: this.companyID};
  
    this.baseDataService.Post('PodvrstaDokumentaStavka', 'UpdateOdgLice', parameters, null)
      .subscribe(() => {
        // this.notificationService.success('Uspešno', 'Sačuvan');
        this.toastrService.success('Uspešno', 'Sačuvan');
      })

      this.activeModal.close();
  }

  
}

Close(){
    this.activeModal.dismiss();
}

}
